// removed by extract-text-webpack-plugin
module.exports = {"modalOverlay":"zfNWpf5AAy-SljbBj0dWX","fullscreen":"_2J2WhjfC9nim4IRdftVAxI","modal":"_1a3dTbfGWKzcjUtxjQftf1","scrollable":"_1ek5aB4fG0jmnysdgGJZ-j","modalContainer":"TnhdYxiX6FKHk9igIouKI","modalContent":"g2phzQZTg_pNXxmAfph6m","modalHeader":"_2h5CzbvhMqDx0nipR428h9","modalFooter":"V3ZUxcUjr83GXucS3UmaF","footerButtons":"_Kfl-f7Qm3HQt-RnSvgnF","triggerElementContainer":"gmLkO3IRFxL8u7EceN6D9"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/messaging/modal.scss
// module id = 82
// module chunks = 0